import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { PRODUCT_IMAGE, heroStats } from '../../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy-900 text-white" data-id="element-192" data-mp="cvl5b7gbpium">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1.5 bg-clinic-500" aria-hidden="true" data-id="element-193" data-mp="huo1e2ebseqg" />
      <div className="mx-auto w-full max-w-6xl px-4 pb-10 pt-8 sm:px-6 sm:pb-14 sm:pt-10" data-id="element-194" data-mp="mszc0fcg2t9q">
        <p className="text-center text-sm font-black uppercase tracking-[0.28em] text-clinic-300" data-id="element-195" data-mp="quu9t9v62oir">
          Dr. Karito
        </p>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-196" data-mp="vmvspemubdhr">
          <div className="order-2 lg:order-1" data-id="element-197" data-mp="10k43gu5nsf8z">
            <h1 className="text-balance text-center text-[26px] font-black leading-[1.12] tracking-tight sm:text-4xl lg:text-left lg:text-[42px]" data-id="element-198" data-mp="15kid2gmwrx94">
              Solve an entire year of clinical decisions in diabetes in just{' '}
              <span className="text-clinic-300" data-id="element-199" data-mp="9o2rvr4dz0pp">2 minutes per patient</span>
            </h1>

            <p className="mt-4 text-pretty text-center text-[15px] leading-relaxed text-navy-100 sm:text-lg lg:text-left" data-id="element-200" data-mp="4o6ljl87ux6z">
              More than 2,000 physicians already trust the Clinical Decision System. Walk into your
              consultation with everything you need to diagnose, treat, and protect your patients
              with diabetes — without second-guessing every decision.
            </p>

            <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-4" data-id="element-201" data-mp="nextcick2fj9">
              <p className="text-center text-[13px] font-bold leading-snug text-white sm:text-base lg:text-left" data-id="element-202" data-mp="inz957og4xaq">
                Clinical Decision System for Diabetes
              </p>
              <p className="mt-1 text-center text-[11px] font-black uppercase tracking-wider text-clinic-300 sm:text-xs lg:text-left" data-id="element-203" data-mp="1b4s6l10se641">
                6 Volumes + 5 Clinical Tools + Mobile Access
              </p>
            </div>

            <div id="hero-cta" className="mt-6" data-id="element-204" data-mp="30myr0l3lh9hl">
              <CTAButton subtext="Instant download • One-time payment • Lifetime access • 7-day guarantee" data-id="element-205" data-mp="30o9uskx1ih8p">
                ✅ I want access to the Clinical Decision System
              </CTAButton>
            </div>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 lg:justify-start" data-id="element-206" data-mp="2vv76osb17zzw">
              {['Evidence-based', 'Mobile ready', 'Lifetime access'].map(item => <li key={item} className="flex items-center gap-1.5 text-xs font-semibold text-navy-100" data-id="element-207" data-mp="2muis9whq7xmh">
                  <CheckCircle2Icon className="h-4 w-4 text-clinic-300" aria-hidden="true" data-id="element-208" data-mp="27xi2hyj3icqn" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="order-1 lg:order-2" data-id="element-209" data-mp="65viwi1j9k47">
            <img src={PRODUCT_IMAGE} alt="Clinical Decision System for Diabetes: 6 volumes, clinical checklists, renal dosing guide, tablet and phone access" className="mx-auto w-full max-w-[420px] drop-shadow-[0_20px_40px_rgba(0,0,0,0.45)] lg:max-w-none" loading="eager" data-id="element-210" data-mp="676ngk2syvwd" />
          </div>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-211" data-mp="25dc03va4quc7">
          {heroStats.map(stat => <div key={stat.label} className="rounded-2xl border border-white/10 bg-white/5 px-3 py-4 text-center" data-id="element-212" data-mp="20l2cilwhm6d3">
              <dt className="sr-only" data-id="element-213" data-mp="2abx0bupdte0n">{stat.label}</dt>
              <dd data-id="element-214" data-mp="2ab53kgk1ta8s">
                <span className="block text-2xl font-black tracking-tight text-clinic-300 sm:text-3xl" data-id="element-215" data-mp="2abn59sphcgo3">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase leading-tight tracking-wider text-navy-100 sm:text-xs" data-id="element-216" data-mp="2jcbnkzlwp36s">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-[11px] font-semibold uppercase tracking-wide text-navy-200 sm:text-xs" data-id="element-217" data-mp="p0ok6ooy7ues">
          <ShieldCheckIcon className="h-4 w-4 shrink-0 text-clinic-300" aria-hidden="true" data-id="element-218" data-mp="vdsqbz1f1n1k" />
          Currency is converted automatically at checkout
        </p>
      </div>
    </header>;
}